import {Component, OnInit, OnDestroy} from '@angular/core';
import {ConsultaService} from 'src/app/services/consulta.service';
import {Md5} from 'ts-md5/dist/md5';
import {Login} from '../../models/login';
import {Router} from '@angular/router';
import {AlertController} from '@ionic/angular';
import {Storage} from '@ionic/storage';
import {Data} from '../../services/config';
import { propietario } from '../../services/config';

// import { AppPreferences } from '@ionic-native/app-preferences/ngx';


@Component({
    selector: 'app-acceder',
    templateUrl: './acceder.page.html',
    styleUrls: ['./acceder.page.scss'],
    providers: []
})
export class AccederPage implements OnInit, OnDestroy {

    public login: Login;
    public _email: string;
    public _code: string;

    constructor(
        public _consulta: ConsultaService,
        public _router: Router,
        public alertController: AlertController,
        public _storage: Storage,
    ) {
        this.login = new Login();
        this._email = Data.email;
        this._code = Data.code;
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.login = new Login();
    }

    onSubmit() {
        if (!this.login.email || !this.login.password) {
            this.alertErrorLogin('¡Error!', 'Por favor, introduce tus datos.');
        };

        const myCode = Md5.hashStr(this.login.password);

        let payload = '{"clave" : "LOGIN", "email" : "' + this.login.email + '","code" : "' + myCode + '","id" : "' + propietario + '"}';
        this._consulta.postPlaza(payload).subscribe(
            (data) => {
                this._consulta.usuario.Id = data['id'];
                this._consulta.usuario.Nombre = data['nombre'];
                this._consulta.usuario.Apellidos = data['apellidos'];
                this._storage.set('email', this.login.email);
                this._storage.set('password' , myCode);
                this._storage.set('id_user', this._consulta.usuario.Id);
                if (this._consulta.usuario.Id == null) {
                    this.alertErrorLogin('¡Error!', 'Usuario o contraseña erróneos.');
                } else {
                    this._router.navigate(['/principal']);
                };
            },
            error => {
                error;
                this.alertErrorLogin('¡Error!', 'Usuario o contraseña erróneos.');
            }
        );
    }

    async alertErrorLogin(hdr: string, msg: string) {
        const alert = await this.alertController.create({
            header: hdr,
            message: msg,
            buttons: [{
                text: 'OK'
            }]
        });
        await alert.present();
    }


}
